function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ff9583;}.cls-2{fill:#495771;stroke:#495771;stroke-miterlimit:10;}"));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "FastDelivery");

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-1",
  cx: 41.5,
  cy: 19.5,
  r: 13
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M98,65V81H89a6,6,0,0,0-12,0H70V48H87Zm-7,0L85,55H77V65Z",
  transform: "translate(-0.5 -11.5)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M23.75,82H14a1,1,0,0,1-1-1V31a1,1,0,0,1,1-1H24v2H15V80h8.75Z",
  transform: "translate(-0.5 -11.5)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M30,88a7,7,0,1,1,7-7A7,7,0,0,1,30,88Zm0-12a5,5,0,1,0,5,5A5,5,0,0,0,30,76Z",
  transform: "translate(-0.5 -11.5)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M42,50A19,19,0,1,1,61,31,19,19,0,0,1,42,50Zm0-36A17,17,0,1,0,59,31,17,17,0,0,0,42,14Z",
  transform: "translate(-0.5 -11.5)"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-2",
  x: 4.5,
  y: 45.5,
  width: 16,
  height: 2
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-2",
  x: 69.5,
  y: 68.5,
  width: 7,
  height: 2
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M98,82H89V80h8V65.29L86.46,49H70V47H87a1,1,0,0,1,.84.46l11,17A1,1,0,0,1,99,65V81A1,1,0,0,1,98,82Z",
  transform: "translate(-0.5 -11.5)"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M70,82H36.25V80H69V32H60V30H70a1,1,0,0,1,1,1V81A1,1,0,0,1,70,82Z",
  transform: "translate(-0.5 -11.5)"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M83,88a7,7,0,1,1,7-7A7,7,0,0,1,83,88Zm0-12a5,5,0,1,0,5,5A5,5,0,0,0,83,76Z",
  transform: "translate(-0.5 -11.5)"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M91,66H77a1,1,0,0,1-1-1V55a1,1,0,0,1,1-1h8a1,1,0,0,1,.86.49l6,10A1,1,0,0,1,91,66ZM78,64H89.23l-4.8-8H78Z",
  transform: "translate(-0.5 -11.5)"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M48,32.52H42a1,1,0,0,1-1-1v-9h2v8h5Z",
  transform: "translate(-0.5 -11.5)"
});

var _ref16 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-2",
  x: 0.5,
  y: 35.5,
  width: 20,
  height: 2
});

var _ref17 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-2",
  x: 4.5,
  y: 25.5,
  width: 16,
  height: 2
});

var SvgFastDelivery = function SvgFastDelivery(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    viewBox: "0 0 99 77",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFastDelivery, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/FastDelivery.e5e04936.svg";
export { ForwardRef as ReactComponent };